export const AB_TESTS = {
  ST_LEAD_FLOW_NEW_UI: "ST_LEAD_FLOW_NEW_UI", // Matt Moore
  ST_CONVERSATIONAL_CHAT_FLOW: "ST_CONVERSATIONAL_CHAT_FLOW",
  ST_PROPERTY_ADDRESS: "ST_PROPERTY_ADDRESS",
  ST_ZIP_TASK: "ST_ZIP_TASK",
} as const;
